import { proxy } from "valtio";

export const organizationInfoState = proxy<{
  showOrganizationInfo: boolean;
}>({
  showOrganizationInfo: false,
});
